import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const NameContainer = styled.div<{ $isAlignedRight?: boolean }>`
    text-align: ${({ $isAlignedRight }) => ($isAlignedRight ? 'right' : 'left')};
`;

export const WeakName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
`;

export const StrongName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}

    white-space: normal;
`;
